import { useNuxtApp, useState } from "#imports";
export const useOryError = () => {
  const { ssrContext } = useNuxtApp();
  return useState("nuxtOryError", () => ssrContext?.event?.context?._nuxtOry?.error ?? null);
};
export const useOrySession = () => {
  const { ssrContext } = useNuxtApp();
  return useState("nuxtOry", () => ssrContext?.event?.context?._nuxtOry?.session ?? null);
};
export const useOryState = () => ({
  session: useOrySession(),
  error: useOryError()
});
